import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Modal from '../../Modal';
import NavBar from '../../NavBar';
import Sauce from './Sauce';

import styles from './MobileView.styl';

const cx = classNames.bind(styles);

class MobileView extends PureComponent {
  static defaultProps = {
    className: '',
  };

  static propTypes = {
    className: PropTypes.string,
    list: PropTypes.array.isRequired,
    panelOpened: PropTypes.bool.isRequired,
    avaivableCount: PropTypes.number.isRequired,
    addFreeSauce: PropTypes.func.isRequired,
    hideFreeSaucesPanel: PropTypes.func.isRequired,
  };

  render() {
    const {
      className,
      list,
      panelOpened,
      addFreeSauce,
      avaivableCount,
      hideFreeSaucesPanel,
    } = this.props;

    return (
      <Modal
        className={cx('FreeSaucesPanel', className)}
        isOpen={panelOpened}
        direction="left"
        onClose={hideFreeSaucesPanel}>
        <FormattedMessage id="freeSauces.panel.title" values={{ count: avaivableCount }}>
          {title => (
            <NavBar
              className={cx('FreeSaucesPanel__navbar')}
              title={title}
              onBack={hideFreeSaucesPanel}
            />
          )}
        </FormattedMessage>
        <div className={cx('FreeSaucesPanel__list')}>
          {list.map(sauce => (
            <Sauce
              key={sauce.alias}
              className={cx('FreeSaucesPanel__item')}
              addToCart={addFreeSauce}
              {...sauce}
            />
          ))}
        </div>
      </Modal>
    );
  }
}

export default MobileView;
